import { render, staticRenderFns } from "./TradePageGpItem.vue?vue&type=template&id=70cd5716&scoped=true&"
import script from "./TradePageGpItem.vue?vue&type=script&lang=js&"
export * from "./TradePageGpItem.vue?vue&type=script&lang=js&"
import style0 from "./TradePageGpItem.vue?vue&type=style&index=0&id=70cd5716&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70cd5716",
  null
  
)

export default component.exports